import React from 'react'
import { stepStyle } from './style'
import {
    Table,

} from '@devexpress/dx-react-grid-material-ui';
const TableRow = ({ row, ...restProps }) => {

    return (
        <Table.Row
            {...restProps}
            // onClick={() => alert(JSON.stringify(row))}
            style={row.type === 'step' ? stepStyle : null}
        />
    )
}

export default TableRow
